const five={
	title: '`housing` - це ми',
	img:[
		'bi/al_ovchinnikova.jpg',
		'bi/940x1410_0xc0a839a4_6912462991475681269.jpeg',
		'bi/58731274.png',
		'bi/7a7478039_2376672.png',
	],
	text: '`HOUSING` - це, перш за все, люди, котрі роблять свою справу\
		з любов’ю і більш за все прагнуть поділитися цим почуттям із кожним клієнтом,\
		завітавшим до нас. Наші менеджери завжди готові відповісти на будь-які Ваші\
		запитання та надати вичерпну професійну консультацію з приводу товару,\
		який Вас зацікавив. Ваша довіра до нас та зацікавленість в нашій продукції\
		спонукає нас до постійного розвитку та самовдосконалення. Наша основна мета –\
		задовольнити Ваші найвибагливіші потреби та допомогти у разі необхідності.\
		Звертайтеся до нас за номерами телефонів, які Ви знайдете в розділі «наші контакти»,\
		чи в соціальних мережах. Також ми завжди будемо раді почути Ваші відгуки\
		щодо нашої роботи та можливі зауваження чи побажання, щодо її покращення!'
};

export default five;